export const DATATEST = {
    INPUT: "reusable__input-field-component__input",
    LABEL: "reusable__input-field-component__label",
    ERROR_ICON: "reusable__input-field-component__error-icon",
    ERROR_MESSAGE: "reusable__input-field-component__error-message",
    HELPER_MESSAGE: "reusable__input-field-component__helper-message",
    START_ICON_WRAPPER: "reusable__input-field-component__start-icon-wrapper",
};
